import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const TagMeaningInput = () => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("tagMeaning")}
      placeholder={t("tagMeaningPlaceholder")}
      id="tag_meaning"
      type="text"
      autoComplete="tag-meaning"
      required={true}
      helperText={null}
      multiline={true}
    />
  );
};
export default TagMeaningInput;